import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import Spin from '../../../components/loading';

import * as reserveTimeActions from '../../../redux/reserveTimes/actions';

const ReserveDayDetailsModal = props => {
  let { loading, message, error, failed, reservationDayId, reservationDayDetails } = props;

  useEffect(() => {
    props.fetchReservationDayDetails(reservationDayId);
  }, []);

  return (
    <Spin spinning={loading}>
      <article>
        <main className="panel panel-default">
          {error && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
          {failed && <div className="alert alert-danger">{message}</div>}
          <Modal id="financial-transaction-modal" size="xl" isOpen={props.isOpen}>
            <ModalHeader>
              <div className="row">
                <div className="col-11">{locales('titles.reservationDayDetails')}</div>
                <div className="col-1 text-left">
                  <a
                    href="#"
                    className=""
                    onClick={event => {
                      event.preventDefault();
                      props.closeModal();
                    }}
                  >
                    <i className="fas fa-times"></i>
                  </a>
                </div>
              </div>
            </ModalHeader>
            <ModalBody>
              <Spin spinning={loading}>
                <article>
                  {error && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
                  {failed && <div className="alert alert-danger">{message}</div>}
                  <div className="col-12 p-0">
                    <div className="col-12 p-0">{locales('titles.sureToDeleteReservationDay')} ؟</div>
                  </div>
                </article>
              </Spin>
            </ModalBody>
          </Modal>
        </main>
      </article>
    </Spin>
  );
};

const mapStateToProps = state => {
  return {
    loading: state.reserveTimesReducer.reservationDayDetailsLoading,
    error: state.reserveTimesReducer.reservationDayDetailsError,
    failed: state.reserveTimesReducer.reservationDayDetailsFailed,
    message: state.reserveTimesReducer.reservationDayDetailsMessage,
    reservationDayDetails: state.reserveTimesReducer.reservationDayDetails
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchReservationDayDetails: id => dispatch(reserveTimeActions.fetchReservationDayDetails(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReserveDayDetailsModal);
